import { render, staticRenderFns } from "./shippingDetails.vue?vue&type=template&id=6ecfcfec&scoped=true&"
import script from "./shippingDetails.vue?vue&type=script&lang=js&"
export * from "./shippingDetails.vue?vue&type=script&lang=js&"
import style0 from "./shippingDetails.vue?vue&type=style&index=0&id=6ecfcfec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecfcfec",
  null
  
)

export default component.exports